import styles from "./ToggleDeviceRead.module.scss";
import Toggle from "components/MainApp/atoms/Forms/Toggle";
import i18n from "i18n";

const ToggleDeviceRead = ({ handleToggleChange, disableToggle, channel }) => {
  return (
    <div className={styles["toggle-wrapper"]}>
      <p>
        <span>{channel ? i18n.t("reading.enabled") : i18n.t("reading.disabled")}</span>
      </p>
      <Toggle
        handleChange={() => handleToggleChange(channel)}
        checked={channel}
        disabled={disableToggle}
        name="channel"
      />
    </div>
  );
};

export default ToggleDeviceRead;
